// https://doc2.ixiaochuan.cn/pages/viewpage.action?pageId=4651655
import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'
import {camelizeKeys, decamelizeKeys} from 'humps'
import {BillDetailMock, FriendListMock, JoinMock, packetListMock} from './mock'

const GET_RECHARGE_GROUP_LIST = 'GET_RECHARGE_GROUP_LIST'
export const getRechargeGroupList = createAsyncThunk(
  GET_RECHARGE_GROUP_LIST,
  async (_, store: any) => {
    // // todo mock
    // return camelizeKeys(packetListMock)
    const res = await http.post('/live/activity/sb_packet_list', {
      ...store.getState().env.deviceinfo,
    })
    return camelizeKeys(res.data)
  }
)

const GET_GROUP_DETAIL = 'GET_GROUP_DETAIL'
export const getGroupDetail = createAsyncThunk(
  GET_GROUP_DETAIL,
  async (p: any, store: any) => {
    // // todo mock
    // return camelizeKeys(BillDetailMock)
    const args = decamelizeKeys(p)
    const res = await http.post('/live/activity/sb_bill_detail', {
      ...store.getState().env.deviceinfo,
      ...args,
    })
    return camelizeKeys(res.data)
  }
)

const JOIN_RECHARGE_GROUP = 'JOIN_RECHARGE_GROUP'
export const joinRechargeGroup = createAsyncThunk(
  JOIN_RECHARGE_GROUP,
  async (p: any, store: any) => {
    // // todo mock
    // return camelizeKeys(JoinMock)
    const args = decamelizeKeys(p)
    const res = await http.post('/live/activity/sb_share_bill', {
      ...store.getState().env.deviceinfo,
      ...args,
    })
    return camelizeKeys(res.data)
  }
)

const GET_SHARE_LIST = 'GET_SHARE_LIST'
// 获取可分享的用户列表
export const getShareList = createAsyncThunk(
  GET_SHARE_LIST,
  async (_, store: any) => {
    // // todo mock
    // return camelizeKeys(FriendListMock)
    const res = await http.post('/live/activity/sb_share_list', {
      ...store.getState().env.deviceinfo,
    })
    return camelizeKeys(res.data)
  }
)

const SEND_INVITE_MSG = 'SEND_INVITE_MSG'
// 分享邀请链接给其他用户
export const sendInviteMsg = createAsyncThunk(
  SEND_INVITE_MSG,
  async (p: any, store: any) => {
    const args = decamelizeKeys(p)
    const res = await http.post('/live/activity/sb_share_send', {
      ...store.getState().env.deviceinfo,
      ...args,
    })
    return camelizeKeys(res.data)
  }
)

const initialState = {
  packetList: [],
  shareBills: [],
  billId: false,
  billExpire: 0,
  orderInfo: {
    shareNum: 0,
    billExpire: 0,
  },
  userList: [],
  shareLimit: 0,
}

export const RechargeGroupSlice = createSlice({
  name: 'rechargeGroup',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getRechargeGroupList.fulfilled, (state, action) => {
      const {data = {}} = action.payload
      Object.assign(state, {
        ...data,
      })
    })
    builder.addCase(getGroupDetail.fulfilled, (state, action) => {
      const {data = {}} = action.payload
      Object.assign(state, {
        orderInfo: data,
      })
    })
    builder.addCase(getShareList.fulfilled, (state, action) => {
      const {data = {}} = action.payload
      Object.assign(state, {
        userList: data?.userList,
      })
    })
  },
})

export default RechargeGroupSlice.reducer
